<style scoped>
    @import url("../../../styles/smartControl/formSC_v2.scss");
</style>

<template>
    <div class="box_form2">

        <v-form class="form_painel"
        ref="form"
        v-model="valid"
        lazy-validation
        >

            <div class="tit_form">{{ nomeSys }}</div>

            <v-divider class="mt-4 mb-4"></v-divider>

            <div class="def_prod_form">

                <div class="tit_def_prod">Definição de produção</div>

                <div class="subpainel_prod">

                    <v-chip 
                    @click="changeProd(i)"
                    class="mr-2 mb-1 el_radios" 
                    variant="elevated" 
                    v-for="(p,i) in liDefProd" :key="i"
                    :style="{'background':p.backcor,'cursor':'pointer'}"
                    >
                        <span>{{ p.nome }}</span>
                    </v-chip>
                    
                </div>

                <v-expansion-panels accordion class="cardExpansor">

                    <v-expansion-panel class="el_cardExpansor mt-1">

                        <v-expansion-panel-title class="titCardExpansor">Estrutura da operação</v-expansion-panel-title>

                        <v-expansion-panel-text class="respCardExpansor">
                            <div class="subtit_def_prod">Cultura</div>

                            <div class="subpainel_prod">

                                <v-text-field
                                :rules="nameRules"
                                hint="Informe o cultivo"
                                color="#F39C12"
                                v-model="el_doc.cultura"
                                label="Ex.: Cerejeira Nimba"
                                required
                                style="width: 200px;"
                                ></v-text-field>

                            </div>

                            <div class="subtit_def_prod">Último resultado safra [toneladas]</div>

                            <div class="subpainel_prod">

                                <v-text-field
                                type="number"
                                hint="Informe a quantidade produzida na última safra"
                                color="#F39C12"
                                v-model="el_doc.last_safra"
                                label="Ex.: 0.2"
                                required
                                style="width: 200px;"
                                ></v-text-field>

                            </div>

                            <div class="subtit_def_prod">Dimensão do vaso [litros]</div>

                            <v-radio-group inline v-model="rBtnVaso">
                                <v-radio label="Produção com vaso" value="Produção com vaso"></v-radio>
                                <v-radio label="Produção sem vaso" value="Produção sem vaso"></v-radio>
                            </v-radio-group>

                            <div class="subpainel_prod">

                                <v-text-field
                                :rules="currentRules_rBtnVaso"
                                type="number"
                                hint="Informe a quantidade em litros úteis do vaso em que a planta está inserida"
                                color="#F39C12"
                                v-model="el_doc.volume_util_vaso_litros"
                                label="Ex.: 14.7"
                                required
                                style="width: 200px;"
                                ></v-text-field>

                            </div>

                            <div class="subtit_def_prod">Potência iluminação artificial [W]</div>

                            <v-radio-group inline v-model="rBtnIA">
                                <v-radio label="Produção com iluminação artificial" value="Produção com iluminação artificial"></v-radio>
                                <v-radio label="Produção sem iluminação artificial" value="Produção sem iluminação artificial"></v-radio>
                            </v-radio-group>

                            <div class="subpainel_prod">

                                <v-text-field
                                :rules="currentRules_rBtnIA"
                                type="number"
                                hint="Informe a quantidade em watts"
                                color="#F39C12"
                                v-model="el_doc.potencia_luz_w"
                                label="Ex.: 600"
                                required
                                style="width: 200px;"
                                ></v-text-field>

                            </div>

                            <div class="subtit_def_prod">Dimensão do terreno [m2]</div>

                            <div class="subpainel_prod">

                                <v-text-field
                                :rules="nameRules"
                                type="number"
                                hint="Informe a quantidade de área do terreno em metros quadrados"
                                color="#F39C12"
                                v-model="el_doc.area_m2"
                                label="Ex.: 0.8"
                                required
                                style="width: 200px;"
                                ></v-text-field>

                            </div>

                            <div class="subtit_def_prod">Breve descrição da operação agropecuária</div>

                            <div class="subpainel_prod">

                                <v-text-field
                                :rules="nameRules"
                                hint="Breve descrição da operação (Máximo 50 palavras)"
                                color="#F39C12"
                                v-model="el_doc.desc"
                                label="Máximo 50 palavras"
                                required
                                style="width: 200px;"
                                ></v-text-field>

                            </div>

                            <div v-if="el_doc.tipoSolo"
                            class="subtit_def_prod">Tipo ou textura do solo</div>
                            <div class="subpainel_prod" v-if="el_doc.tipoSolo">
                                <v-text-field
                                :rules="nameRules"
                                hint="Qual a textura depois da correção de solo?"
                                color="#F39C12"
                                v-model="el_doc.tipoSolo"
                                label="Ex.: argiloso"
                                required
                                style="width: 200px;"
                                ></v-text-field>
                            </div>

                            <div class="subtit_def_prod">Quantidade de plantas por área</div>
                            <div class="subpainel_prod">
                                <v-text-field
                                :rules="nameRules"
                                type="number"
                                hint="Quantas plantas no terreno?"
                                color="#F39C12"
                                v-model="el_doc.qnt_plantas"
                                label="Ex.: 45"
                                required
                                style="width: 200px;"
                                ></v-text-field>
                            </div>

                            <div class="subtit_def_prod">Profundidade do bulbo molhado [metros]</div>
                            <div class="subpainel_prod">
                                <v-text-field
                                :rules="nameRules"
                                type="number"
                                hint="Qual a profundidade de infiltração da água? 30cm = 0.3m"
                                color="#F39C12"
                                v-model="el_doc.bulbo_molhado_profundidade_m"
                                label="Ex.: 0.3"
                                required
                                style="width: 200px;"
                                ></v-text-field>
                            </div>

                            <div class="subtit_def_prod">Área superficial bulbo molhado [m2]</div>
                            <div class="subpainel_prod">
                                <v-text-field
                                :rules="nameRules"
                                type="number"
                                hint="Qual o tamanho da área que fica molhada por planta? 0.4 metros quadrados"
                                color="#F39C12"
                                v-model="el_doc.bulbo_molhado_superficial_m2"
                                label="Ex.: 0.4"
                                required
                                style="width: 200px;"
                                ></v-text-field>
                            </div>

                            <div class="subtit_def_prod">Capacidade retenção do solo [%]</div>
                            <div class="subpainel_prod">
                                <v-text-field
                                :rules="nameRules"
                                type="number"
                                hint="A sua amostra de solo pode indicar o FC"
                                color="#F39C12"
                                v-model="el_doc.capacidade_retencao_s_perc"
                                label="Ex.: 42%"
                                required
                                style="width: 200px;"
                                ></v-text-field>
                            </div>

                            <div class="subtit_def_prod">Ponto de murcha [%]</div>
                            <div class="subpainel_prod">
                                <v-text-field
                                :rules="nameRules"
                                type="number"
                                hint="A sua amostra de solo pode indicar o PMP"
                                color="#F39C12"
                                v-model="el_doc.pmp_perc"
                                label="Ex.: 18%"
                                required
                                style="width: 200px;"
                                ></v-text-field>
                            </div>

                            <!-- OPCIONAL -->
                            <div class="subtit_def_prod">Fator calibração sensor solo</div>
                            <div class="subpainel_prod">
                                <v-text-field
                                type="number"
                                hint="Se houver, indique o fator de correção"
                                color="#F39C12"
                                v-model="el_doc.fator_calibr_u_s"
                                label="Ex.: 1.3"
                                required
                                style="width: 200px;"
                                ></v-text-field>
                            </div>

                            <!-- Obrigatório devido às previsões locais -->
                            <div class="subtit_def_prod">Latitude</div>
                            <div class="subpainel_prod">
                                <v-text-field
                                type="number"
                                :rules="nameRules"
                                hint="Indique a latitude do local de produção"
                                color="#F39C12"
                                v-model="el_doc.latitude"
                                label="Ex.: 30.13"
                                required
                                style="width: 200px;"
                                ></v-text-field>
                            </div>

                            <!-- Obrigatório devido às previsões locais -->
                            <div class="subtit_def_prod">Longitude</div>
                            <div class="subpainel_prod">
                                <v-text-field
                                type="number"
                                :rules="nameRules"
                                hint="Indique a longitude do local de produção"
                                color="#F39C12"
                                v-model="el_doc.longitude"
                                label="Ex.: -7.18"
                                required
                                style="width: 200px;"
                                ></v-text-field>
                            </div>

                            <!-- OPCIONAL (quando houver rega) -->
                            <div class="subtit_def_prod">Vazão [litros por minuto]</div>
                            <!-- :rules="nameRules" required -->
                            <div class="subpainel_prod">
                                <v-text-field
                                type="number"
                                hint="Informe quantos litros por minuto o sistema de rega opera"
                                color="#F39C12"
                                v-model="el_doc.litros_por_minutos_por_planta"
                                label="Ex.: 1.5"
                                style="width: 200px;"
                                ></v-text-field>
                            </div>

                            <!-- OPCIONAL (quando houver rega) -->
                            <div class="subtit_def_prod">Quantidade máxima por rega [minutos]</div>
                            <div class="subpainel_prod">
                                <v-text-field
                                type="number"
                                hint="Informe quantos minutos no máximo o sistema pode regar"
                                color="#F39C12"
                                v-model="el_doc.minutos_max_por_irrig"
                                label="Ex.: 12"
                                style="width: 200px;"
                                ></v-text-field>
                            </div>

                            <!-- OPCIONAL (quando houver rega) -->
                            <div class="subtit_def_prod">Quantidade mínima por rega [minutos]</div>
                            <div class="subpainel_prod">
                                <v-text-field
                                type="number"
                                hint="Informe quantos minutos no mínimo o sistema pode regar"
                                color="#F39C12"
                                v-model="el_doc.minutos_min_por_irrig"
                                label="Ex.: 5"
                                style="width: 200px;"
                                ></v-text-field>
                            </div>

                        </v-expansion-panel-text>

                    </v-expansion-panel>

                </v-expansion-panels>

                <v-btn 
                class="mt-2"
                color='green'
                block 
                :disabled="!valid"
                @click="update()"
                >
                    Atualizar
                </v-btn>

            </div>

        </v-form>

    </div>
</template>

<script>
// @keyup.enter.prevent="chamada()"
// :rules="nameRules"

export default {

    props:['nomeSys','payloadSys'],

    data() {
        return {
            // validação form
            valid: false, // btn 'entrar' inicia desabilitado.
            nameRules: [
                v => !!v || 'Preenchimento obrigatório',
            ],
            // :rules="nameRules" <--- add no elemento html

            // form / vars
            toneladas:0.2,

            // form / def produção radios
            liDefProd:[
                {'nome':'Agricultura','backcor':'','selected':'off'},
                {'nome':'Agricultura (Estufa)','backcor':'','selected':'off'},
                {'nome':'Agricultura (Indoor)','backcor':'#1F7AB1','selected':'on'},
                {'nome':'Pecuária','backcor':'','selected':'off'}
            ],

            // -- radios (vaso)
            rBtnVaso:'Produção com vaso',
            nameRulesObrigatoria_rBtnVaso: [
                v => !!v || 'Preenchimento obrigatório',
            ],
            nameRulesOpcional_rBtnVaso: [],
            currentRules_rBtnVaso: [],  // Essa será vinculada ao input

            //
            rBtnIA:'Produção com iluminação artificial',
            nameRulesObrigatoria_rBtnIA: [
                v => !!v || 'Preenchimento obrigatório',
            ],
            nameRulesOpcional_rBtnIA: [],
            currentRules_rBtnIA: [],  // Essa será vinculada ao input

            // form / doc geral 
            el_doc:{},
            el_doc_init:{

                'nome':"upinc_demo",
                'prod':'Agricultura (Indoor)', // padronizar mesma key 

                'cultura':'',
                'last_safra':'',
                'volume_util_vaso_litros':'',
                'potencia_luz_w':'',
                'area_m2':'',
                'desc':'',

                'qnt_plantas':1.0,
                'bulbo_molhado_profundidade_m':"",
                'bulbo_molhado_superficial_m2':"",
                'capacidade_retencao_s_perc':"",
                'fator_calibr_u_s':1.0, // fator init neutro (opcional)
                'latitude':"",
                'longitude':"",
                'pmp_perc':"",

                'litros_por_minutos_por_planta':"", // added 18/05/2026
                'minutos_max_por_irrig':"", // added 18/05/2026
                'minutos_min_por_irrig':"", // added 18/05/2026
            },

        }
    },

    methods:{
        
        changeProd(i) {
            // -- selecionar escolha via click.
            this.liDefProd[i].selected = 'on'
            this.liDefProd[i].backcor = '#1F7AB1'
            let c=0
            while (c < this.liDefProd.length) {
                // -- se não estiver 'on' então desabilitar cor de confirmação.
                if (c != i) { this.liDefProd[c].backcor = ''; this.liDefProd[c].selected = 'off' }
                c++
            }
            // -- update main payload.
            this.el_doc['prod'] = this.liDefProd[i]['nome']
            this.valid = true // habilitar btn "atualizar" | será ainda verificado ao click.
        },

        update() {

            this.$emit('upFromChild', this.el_doc)
        },

        initVasoELuz(payloadSys) {

            if (payloadSys['volume_util_vaso_litros'] == "") { this.rBtnVaso = 'Produção sem vaso' }
            else { this.rBtnVaso = 'Produção com vaso' }

            if (payloadSys['potencia_luz_w'] == "") { this.rBtnIA = 'Produção sem iluminação artificial' }
            else { this.rBtnIA = 'Produção com iluminação artificial' }
        },

        initForm() {

            this.initVasoELuz(this.payloadSys) // (init vars) rcv via props

            // -- espelhar doc init ---> doc de trabalho
            this.el_doc = JSON.parse(JSON.stringify(this.payloadSys)); // -- copia nova.
            //this.el_doc = this.payloadSys // obj a ser mutado.

            // -- ajustar exibição da lista controle radious | liDefProd
            let c=0
            while (c < this.liDefProd.length) {
                // -- se não estiver 'on' então desabilitar cor de confirmação.
                if (this.el_doc.prod == this.liDefProd[c].nome) { 
                    this.liDefProd[c].backcor = '#1F7AB1'
                    this.liDefProd[c].selected = 'on'
                } else {
                    this.liDefProd[c].backcor = ''
                    this.liDefProd[c].selected = 'off'
                }
                c++
            }
        },
    },

    watch: {
        rBtnVaso(val) {
            if (val === 'Produção com vaso') {  // ou qualquer valor que você use para representar a obrigatoriedade
                this.currentRules_rBtnVaso = this.nameRulesObrigatoria_rBtnVaso;
            } else {
                this.currentRules_rBtnVaso = this.nameRulesOpcional_rBtnVaso;
            }
            console.log('watch1')
        },

        rBtnIA(val) {
            if (val === 'Produção com iluminação artificial') {  // ou qualquer valor que você use para representar a obrigatoriedade
                this.currentRules_rBtnIA = this.nameRulesObrigatoria_rBtnIA;
            } else {
                this.currentRules_rBtnIA = this.nameRulesOpcional_rBtnIA;
            }
            console.log('watch2')
        }
    },

    // -- inicialização watch -> rBtnVaso e rBtnIA.
    mounted() {
        // -- radios vaso de produção [litros]
        this.currentRules_rBtnVaso = this.nameRulesObrigatoria_rBtnVaso;
        // -- radios iluminação artificial.
        this.currentRules_rBtnIA = this.nameRulesObrigatoria_rBtnIA;
    },

    created() {
        this.initForm()
    }
}
</script>